import React from 'react';
import PropTypes from 'prop-types';
import Typography, {
  typographyVariants,
  typographyFontWeight,
} from '@weave-mui/typography';
import { Box } from '@weave-mui/material';

function PageTitle(props) {
  return (
    <Box
      className="page-title"
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        mb: '8px',
      }}
    >
      <Box className="title-wrapper">
        <Typography
          variant={typographyVariants.H1}
          fontWeight={typographyFontWeight.BOLD}
          sx={{
            fontFamily:
              '"ArtifaktElement", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif !important',
            fontSize: '28px',
          }}
        >
          {props.title}
        </Typography>
        {props.description && (
          <Typography
            variant={typographyVariants.BODY}
            fontWeight={typographyFontWeight.REGULAR}
            sx={{
              fontFamily:
                '"ArtifaktElement", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif !important',
            }}
          >
            {props.description}
          </Typography>
        )}
      </Box>
      <Box className="children-wrapper">{props.children}</Box>
    </Box>
  );
}

PageTitle.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  learnMoreText: PropTypes.string,
  learnMoreLink: PropTypes.string,
};

PageTitle.defaultProps = {
  description: '',
  learnMoreText: '',
  learnMoreLink: '',
};

export default PageTitle;
